import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.query", [
    "$location", "$route",
    function($location, $route) {

        // This directive will use the attached model's value to set a browser
        // query parameter. And if the page is refreshed or the back button
        // is pressed it will set the value of the model to what was stored
        // in the query parameter

        var expose = {};

        expose.restrict = "A";
        expose.require = "ngModel";
        expose.scope = {
            query: "=",
            queryName: "="
        };

        expose.link = function($scope, element, attributes, controller) {

            // Don't allow the page to reload when the search parameters are changed
            $route.current.$$route.reloadOnSearch = false;

            if ($location.search()[$scope.queryName] !== undefined) {
                // if the query parameter is already set then use that.
                // This happens when the user refreshes the page
                $scope.query[$scope.queryName] = $location.search()[$scope.queryName];
                controller.$setViewValue($scope.query[$scope.queryName]);
                controller.$render();
            }

            $scope.updateQuery = function() {
                if ($scope.queryName && $location.search()[$scope.queryName] !== $scope.query) {
                    // keep the query parameter up to date based on the query data
                    // in case the page is refreshed or the back button pressed
                    $location.search($scope.queryName, $scope.query[$scope.queryName]);
                }
            };

            $scope.$watch("query", function() {
                $scope.updateQuery();
            }, true);

            $scope.$on("$routeUpdate", function() {
                // when the back button is pressed we need to make sure the
                // query parameter updates the model
                $scope.query[$scope.queryName] = $location.search()[$scope.queryName];
            });

        };

        return expose;
    }
]);
